/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S6_Li4Inputs */

const en_guide_large_json_files_s6_li4 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use <a href="/json-formatter">JSON Formatter</a> to format and quickly skim structure, then extract sections of interest`)
};

const ko_guide_large_json_files_s6_li4 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href="/json-formatter">JSON 포맷터</a>로 구조를 포맷하고 빠르게 훑어본 다음, 관심 있는 섹션을 추출`)
};

const ja_guide_large_json_files_s6_li4 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href="/json-formatter">JSONフォーマッター</a>を使用して構造をフォーマット・概観し、関心のあるセクションを抽出`)
};

/**
* | output |
* | --- |
* | "Use <a href=\"/json-formatter\">JSON Formatter</a> to format and quickly skim structure, then extract sections of interest" |
*
* @param {Guide_Large_Json_Files_S6_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s6_li4 = /** @type {((inputs?: Guide_Large_Json_Files_S6_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S6_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s6_li4(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s6_li4(inputs)
	return ja_guide_large_json_files_s6_li4(inputs)
});